import {Control, Controller} from "react-hook-form";
import {TextField} from "@mui/material";

interface FormTextFieldProps {
  name: string;
  control: Control<any>;
  placeholder?: string;
  lines?: number;
}

export function FormTextField(
  {name, control, placeholder, lines}: FormTextFieldProps
) {
  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState: {error}}) => (
        <TextField
          {...field}
          multiline={lines !== undefined}
          rows={lines}
          placeholder={placeholder}
          inputRef={field.ref}
          value={field.value ?? ""}
          onChange={(e) => {
            field.onChange(
              e.target.value
            );
          }}
          fullWidth
          error={!!error?.message}
          helperText={error?.message as string}
          size={"small"}
        />
      )}
    />)
}
